import { H3 } from "@upsolve/ui";
import { get } from "lodash";
import React from "react";
import richTextNodeToComponent from "../Contentful/richTextNodeToComponent";
import ArticleTile from "../Learn/ArticleTile.div";
import AuthorsBlock, { TAuthor, TDateValue, TImageLoading } from "./AuthorsBlock";

type TPageSummary = {
  json?: {
    content?: unknown[];
  } | null;
} | null;

type TLocality = {
  level?: string | null;
  state?: string | null;
  city?: string | null;
} | null;

type TPage = {
  path?: string | null;
  title?: string | null;
  createdAt?: TDateValue;
  updatedAt?: TDateValue;
  author?: TAuthor | null;
  authors?: TAuthor[] | null;
  summary?: TPageSummary;
  locality?: TLocality;
};

type TPageTileProps = {
  page: TPage;
  imageLoading?: TImageLoading;
};

const PageTile = ({ page, imageLoading }: TPageTileProps): React.ReactElement => {
  // Get primary author if it exists
  const primaryAuthor = page.author ? [page.author] : [];

  // Get additional authors, defaulting to empty array if none exist
  const secondaryAuthors = page.authors || [];

  // Combine and filter out any authors without names
  const authors = [...primaryAuthor, ...secondaryAuthors].filter((author) => author && author.name != null);
  const pagePath = page.path || "";
  const pageTitle = page.title || "";

  return (
    <ArticleTile key={pagePath}>
      <div>
        <H3>
          <a href={pagePath}>{pageTitle}</a>
        </H3>
        <AuthorsBlock
          authors={authors}
          createdAt={page.createdAt}
          updatedAt={page.updatedAt}
          imageLoading={imageLoading}
        />
        {Array.isArray(page.summary?.json?.content) && (
          <div className="content-body__lead">
            <div className="summary">
              {page.summary?.json?.content.map((c, i, a) =>
                richTextNodeToComponent(c, i, a, { locality: page?.locality })
              )}
            </div>
          </div>
        )}
        <a href={pagePath}>Read More →</a>
      </div>
    </ArticleTile>
  );
};

export default PageTile;
